import { API } from 'src/constants/api';
import { axiosInterceptor } from 'src/utils/interceptors';

export const taskList = async (payload?: any, signal?: any) => {
    const uri = API.Tasks.list + payload;
    const response = await axiosInterceptor.get(uri, { signal: signal });
    return response;
};
export const taskUpdate = async (payload?: any) => {
    const uri = API.Tasks.update;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const createTask = async (payload?: any) => {
    const uri = API.Tasks.create;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const deleteTask = async (payload?: any) => {
    const uri = API.Tasks.delete + payload;
    const response = await axiosInterceptor.delete(uri);
    return response;
};
